import React from 'react'

export default function Landing({ onLogin }) {
  const handleMicrosoftLogin = () => {
    // Percorso relativo (stessa origine): vedi commento in useAttachmentPreview.js
    window.location.href = '/auth/login'
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#ffffff' }}>
      <style>{`
        :root { color-scheme: light; }
        html, body {
          font-family: 'Outfit', system-ui, -apple-system, sans-serif;
          color: #1e293b;
          background: #ffffff;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          text-rendering: optimizeLegibility;
        }
        .accent {
          background: linear-gradient(90deg, #38bdf8 0%, #2563eb 100%);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
        }
        .hero-glow {
          position: absolute;
          top: -140px; right: -180px;
          width: 760px; height: 760px;
          background: radial-gradient(circle at center,
            rgba(59, 130, 246, 0.22) 0%,
            rgba(125, 211, 252, 0.12) 36%,
            rgba(255, 255, 255, 0) 68%);
          pointer-events: none;
          z-index: 0;
        }
        .chip {
          display: inline-block;
          padding: 0.4rem 0.95rem;
          border-radius: 9999px;
          font-size: 0.72rem;
          font-weight: 700;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #1d4ed8;
          background: rgba(59, 130, 246, 0.10);
        }
        .login-btn {
          display: inline-flex;
          align-items: center;
          gap: 0.55rem;
          background: #0f172a;
          color: #ffffff;
          font-weight: 600;
          font-size: 0.875rem;
          padding: 0.6rem 1.1rem;
          border-radius: 0.7rem;
          text-decoration: none;
          border: none;
          cursor: pointer;
          transition: background 120ms ease, transform 120ms ease, box-shadow 120ms ease;
          box-shadow: 0 8px 22px -12px rgba(15, 23, 42, 0.5);
        }
        .login-btn:hover {
          background: #1e293b;
          transform: translateY(-1px);
          box-shadow: 0 12px 26px -12px rgba(15, 23, 42, 0.6);
        }
        .info-card {
          background: #ffffff;
          border: 1px solid rgba(226, 232, 240, 0.9);
          border-radius: 1.1rem;
          padding: 1.6rem 1.5rem;
          box-shadow:
            0 18px 40px -28px rgba(15, 23, 42, 0.28),
            0 2px 8px -4px rgba(15, 23, 42, 0.05);
          transition: transform 140ms ease, box-shadow 140ms ease;
        }
        .info-card:hover {
          transform: translateY(-3px);
          box-shadow:
            0 26px 50px -30px rgba(30, 64, 175, 0.35),
            0 4px 12px -4px rgba(15, 23, 42, 0.08);
        }
        .info-num {
          width: 40px; height: 40px;
          border-radius: 9999px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-weight: 800;
          font-size: 1rem;
          color: #ffffff;
          background: linear-gradient(135deg, #38bdf8 0%, #3b82f6 50%, #1e40af 100%);
          box-shadow: 0 8px 18px -8px rgba(30, 64, 175, 0.6);
        }
      `}</style>

      {/* Header */}
      <header style={{ width: '100%', borderBottom: '1px solid rgba(226, 232, 240, 0.5)', background: '#ffffff' }}>
        <div style={{ maxWidth: '1536px', margin: '0 auto', padding: '2rem 1.5rem', display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: '1rem' }}>
          <img src="/images/jenia-wordmark.svg" alt="JENIA" style={{ height: '2.5rem', width: 'auto', objectFit: 'contain' }} draggable="false" />
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>
            <button onClick={handleMicrosoftLogin} className="login-btn">
              <svg width="16" height="16" viewBox="0 0 21 21" aria-hidden="true">
                <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
                <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
                <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
                <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
              </svg>
              <span>Accedi con Microsoft</span>
            </button>
          </div>
        </div>
      </header>

      {/* Main */}
      <main style={{ flex: 1 }}>
        {/* Hero */}
        <section style={{ position: 'relative', overflow: 'hidden' }}>
          <div className="hero-glow"></div>
          <div style={{ position: 'relative', maxWidth: '1536px', margin: '0 auto', padding: '2.5rem 1.5rem 5rem 1.5rem' }}>
            <div style={{ maxWidth: '42rem' }}>
              <span className="chip">JENIA ORDINI</span>
              <h1 style={{ marginTop: '1.75rem', fontSize: 'clamp(2rem, 5vw, 3.75rem)', fontWeight: '600', lineHeight: '1.12', letterSpacing: '-0.015em', color: '#0f172a' }}>
                Registrare nuovi ordini<br/>
                <span className="accent">non è mai stato così facile.</span>
              </h1>
              <p style={{ marginTop: '1.75rem', fontSize: '1.125rem', color: '#64748b', lineHeight: '1.6', maxWidth: '32rem' }}>
                Invia una mail con l'ordine, l'agente estrae le informazioni, approva direttamente dalla dashboard e l'ordine è registrato.
              </p>
            </div>
          </div>
        </section>

        {/* 3 Cards */}
        <section style={{ maxWidth: '1536px', margin: '0 auto', padding: '0 1.5rem 6rem 1.5rem', width: '100%' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem' }}>
            <div className="info-card">
              <div className="info-num">1</div>
              <h3 style={{ marginTop: '1.25rem', fontSize: '1.125rem', fontWeight: '600', color: '#1e293b' }}>Dalla email all'estrazione Dati</h3>
              <p style={{ marginTop: '0.5rem', fontSize: '0.875rem', color: '#64748b', lineHeight: '1.6' }}>
                Invia una mail con l'ordine, un agente dedicato estrarrà le informazioni al posto tuo.
              </p>
            </div>
            <div className="info-card">
              <div className="info-num">2</div>
              <h3 style={{ marginTop: '1.25rem', fontSize: '1.125rem', fontWeight: '600', color: '#1e293b' }}>Review Intelligente</h3>
              <p style={{ marginTop: '0.5rem', fontSize: '0.875rem', color: '#64748b', lineHeight: '1.6' }}>
                Dashboard unificata con email e allegati originali, dati estratti dopo match al tuo database.
              </p>
            </div>
            <div className="info-card">
              <div className="info-num">3</div>
              <h3 style={{ marginTop: '1.25rem', fontSize: '1.125rem', fontWeight: '600', color: '#1e293b' }}>Approvazione ed Invio</h3>
              <p style={{ marginTop: '0.5rem', fontSize: '0.875rem', color: '#64748b', lineHeight: '1.6' }}>
                Rivedi l'ordine e conferma con un click l'inserimento dell'ordine.
              </p>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer style={{ borderTop: '1px solid rgba(226, 232, 240, 0.5)', background: '#ffffff' }}>
        <div style={{ maxWidth: '1536px', margin: '0 auto', padding: '2rem 1.5rem', textAlign: 'center' }}>
          <p style={{ fontSize: '0.875rem', color: '#64748b' }}>
            <a href="https://jenia.ai" style={{ fontWeight: '600', color: '#475569', textDecoration: 'none' }}>jenia.ai →</a>
            <span style={{ margin: '0 0.5rem', color: '#cbd5e1' }}>·</span>
            © 2026 JENIA Solutions — Ordini
          </p>
          <p style={{ marginTop: '0.75rem', fontSize: '0.75rem', color: '#94a3b8', lineHeight: '1.6' }}>
            JENIA SOLUTIONS SRL · Viale G. Matteotti 18, 41049 Sassuolo (MO) · P.IVA IT04212150363
          </p>
        </div>
      </footer>
    </div>
  )
}
